var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.additionalComponent,_vm._b({tag:"component",attrs:{"log":"messengers"},on:{"image-dblclick":function($event){return _vm.$emit('image-dblclick')}}},'component',_vm.additionalProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }